export function useSplitOrderResources() {
    return window.ordersplit_resources ?? ({} as Window["ordersplit_resources"]);
}